exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".weforsys-editor-quill[data-v-664d4865] .ql-editor{min-height:400px}.weforsys-editor-quill[data-v-664d4865] .ql-toolbar.ql-snow{border:1px solid #dcdfe6;border-bottom:0;border-radius:4px 4px 0 0}.weforsys-editor-quill[data-v-664d4865] .ql-container.ql-snow{border:1px solid #dcdfe6;border-radius:0 0 4px 4px}", ""]);

// exports
